import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26043558"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "checkbox" }
const _hoisted_2 = ["name", "value"]
const _hoisted_3 = { class: "checkbox_text" }

import { PropType, computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseCheckbox',
  props: {
  name: {
    type: String as PropType<HTMLInputElement['name']>,
    default: '',
  },
  value: {
    type: null,
    required: true,
  },
  label: {
    type: String,
    default: '',
  },
  modelValue: {
    type: null,
    required: true,
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:modelValue', value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props





const isChecked = computed({
  get: () => {
    return props.modelValue;
  },
  set: (value) => {
    emit('update:modelValue', value);
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      class: "checkbox_input",
      type: "checkbox",
      name: props.name,
      value: props.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(isChecked) ? (isChecked).value = $event : null))
    }, null, 8, _hoisted_2), [
      [_vModelCheckbox, _unref(isChecked)]
    ]),
    _createElementVNode("span", _hoisted_3, _toDisplayString(props.label), 1)
  ]))
}
}

})